import makeStyles from "@mui/styles/makeStyles";
import moment from "moment";
import {useDispatch, useSelector} from 'react-redux';
import {
    getConfig, getDraftModeOn,
    setContentView,
    setHourHeight,
} from '../../store/reducers/booked_admissions';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Button from "@mui/material/Button";
import React, {memo, useEffect, useState} from 'react';
import {
    procedureLenString,
    proceduresLen,
    proceduresLenStringTotalTime,
} from '../bookAdmission/workList';
import {generateColor} from './content/calendar/AgyleCalendarDays';
import Divider from '@mui/material/Divider';
import {AlertIcon, BackIcon} from '../../components/icons/icons';
import Grid from '@mui/material/Grid';
import FemaleIcon from '@mui/icons-material/Female';
import MaleIcon from '@mui/icons-material/Male';
import {contentViewTypes} from './content/content';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import _ from 'lodash';
import {Tooltip} from '@mui/material';
import clsx from 'clsx';
import {admissionViewTypes} from './bookedAdmissions';
import {hasBAPermission, Permissions} from '../../store/reducers/user';
import {useTheme} from '@emotion/react';
import {agylePref} from '../../store/reducers/preferences';
import configFile from '../../app/config';

export const useStyles = makeStyles((theme) => ({
    admissionCard: {
        outline: "1px solid "+theme.palette.admissionForm.patientCardBackgroundDarker,
        background: theme.palette.admissionForm.patientCardBackground,
        margin: "5px 0 5px 0",
       // border: "2px solid "+ theme.palette.admissionForm.patientCardBackground,
        padding: 5,
        fontSize: 12,
        width: "calc(100% - 2px)",
        borderBottomLeftRadius: theme.palette.mode === "dark" ? 0 : 2,
        borderTopLeftRadius: theme.palette.mode === "dark" ? 0 : 2,
        borderTopRightRadius: theme.palette.mode === "dark" ? 10 : 6,
        borderBottomRightRadius: theme.palette.mode === "dark" ? 10 : 6,


     //   resize: 'vertical',
   //     overflow: "auto"
    },
    admissionCardDetail: {
        background: theme.palette.mode === "dark" ? "#313233" : "#dee1e5",
        border: "1px solid #494B4C",
        borderRadius: 10,
    },
    admissionCardDetailMarkedOperation: {
        background: theme.palette.mode === "dark" ? "#cdcdcd" : "#8a8a8a",
        border: "1px solid #494B4C",
        borderRadius: 10,
    },
    expandButton: {
        position: "absolute",
        bottom: 0,
        background: theme.palette.admissionForm.patientCardBackground,
        textAlign: "center",
        width: "calc(100% - 1px)",
        borderRadius: 10,
      //  maxHeight: 10
      //  border: "1px solid grey"
    },
    cardSelected: {
        background: "white",
        color: "black"
    },
    patientName: {
        fontWeight: "bold",
        display: "flex",
        alignItems: "center",
        width: "95%",
        justifyContent: "space-between",
        background: theme.palette.admissionForm.patientCardBackground,
    },
    cardFirstBox: {
        display: "flex", flexWrap: "wrap", width: "100%"
    },
    patientNameSize: {
        fontSize: 14
    },
    driver: {
        width: "100%",
        height: 1,
        background: "#626466",
        margin: "8px 0px"
    },
    procedureSpecialty: {
        border: "1px solid grey",
        borderRadius: 8,
        padding: 3,
        width: 70,
        display: "inline-flex",
        justifyContent: "center"
    },
    timeIcon: {
        fontSize: 16,
        color: "#626466",
        marginRight: 4
    },
    procedure: {
        marginBottom: 8,
        display: "flex"
    },
    procedureDescription: {
        marginLeft: 10,
        fontWeight: "bold",
        wordBreak: "break-word",

    },
    priorityDescription:{
        borderRadius: 7,
        background: "gray",
        padding: 4,
        fontWeight: "bold"
    },
    rotate: {
        transform: "rotate(-90deg)",
      //  margin: "5px"
        fontSize: 16
    },
    cardDetails: {
        display: "flex",
        justifyContent: "space-between",
    },
    label: {
      color: theme.palette.bookAdmissions.patientCardTextColor
    },
    details: {
        textAlign: "right",
     //   color: "white"
    },
    femaleIcon: {
        background: "#F4BDD1",
        borderRadius: "4px",
        display: "flex",
        color: "#3D3E40",
        margin: "0 3px 0 3px",
        padding: "2px"
    },
    maleIcon: {
        background: "#92BFE2",
        borderRadius: "4px",
        display: "flex",
        color: "black",
        margin: "0 3px 0 3px",
        padding: "2px"
    },
    unIcon: {
        background: "#313233",
        borderRadius: "4px",
        display: "flex",
        color: "white",
        height: 20,
        width: 20,
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        margin: "0 3px 0 3px",
        fontSize: "11px",
        padding: "12px"
    },
    admissionDetail: {
        display: "flex",
        alignItems: "center",
        padding: 5,
    },
    patientDetails: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    parent: {
        display: "grid",
        alignItems: "center",
        gridTemplateColumns: "1fr 3fr",
        gridTemplateRows: "2fr 1fr",
        gap: "0px 5px",
        gridTemplateAreas: '". ."\n    ". ."'
    },

}));

const AdmissionPatientCard = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const [tooltipText, setTooltipText] = useState("");
    const dispatch = useDispatch();
    const admissionConfig = useSelector(getConfig);
    const getItemStyle = (isSelected, ad, isPast) => {
        let styleItem = {
            userSelect: "none",
            margin: "0 1px 0 1px",
            padding: 0,
            borderLeft: "5px solid red",
            borderLeftColor: generateColor(ad.procedures?.[0]?.specialty)
        }

        if(isSelected){
            styleItem["background"] = theme.palette.bookAdmissions.cardBackground;
            styleItem["borderTopColor"] = "white";
            styleItem["borderRightColor"] = "white";
            styleItem["borderBottomColor"] = "white";
            styleItem["color"] = theme.palette.bookAdmissions.cardText;
        }

        if(ad.cancelInfo?.status === "rebook" && !ad.bookedSession) {
            styleItem["borderTop"] = "5px solid";
            styleItem["borderRight"] = "5px solid";
            styleItem["borderBottom"] = "5px solid";
            styleItem["borderTopColor"] = "#d0d0d0";
            styleItem["borderRightColor"] = "#d0d0d0";
            styleItem["borderBottomColor"] = "#d0d0d0";
        }

        if(ad.patient == null) {
            //styleItem["borderTop"] = "5px solid";
            styleItem["borderRight"] = "5px solid";
            styleItem["borderBottom"] = "5px solid";
            //styleItem["borderTopColor"] = "#e50f0f";
            styleItem["borderRightColor"] = "#e50f0f";
            styleItem["borderBottomColor"] = "#e50f0f";
        }

        if(isPast) {
          //  styleItem.border = "5px solid red";
         //   styleItem.borderColor = generateColor(ad.procedures?.[0]?.specialty);
            styleItem["color"] = "#817575"
        }

        return styleItem
    };

    const priorityColors = (priority) => {
        if (priority) {
            const priorityCfg = _.find(admissionConfig.priority, (p) => {
                return p.description.toString().toLowerCase() == priority.toString().toLowerCase();
            })
            if (priorityCfg && priorityCfg.hasOwnProperty("color")) {
                return priorityCfg.color;
            } else {
                return "#313233"
            }
        } else {
            return "#313233"
        }
        // switch(priority) {
        //     case "Routine":
        //         return "#2180F7";
        //     case "Planned":
        //         return "#2180F7";
        //     case "Urgent":
        //         return "#f7a202";
        //     case "Fast Track":
        //         return "#f7a202";
        //     case "Trauma":
        //         return "#e25b61";
        //     case "Emergency":
        //         return "#b43238";
        //     default:
        //         return "#313233"
        // }
    }

    const userCanEditForm = () => {
        if(props.ad.patient === null) return false;
        if(admissionViewTypes.THEATRES === props.ad.opType) return dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_T_TCI_SL, props.ad.opType));
        if(admissionViewTypes.MDU === props.ad.opType) return dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_MDU_ON_SL, props.ad.opType));
    }

    const saveEndSurgery = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if(props.endSurgery && !props.ad.endSurgery)
            props.endSurgery(props.ad)
    }

    const handleExpandItem = (e) => {
        const cardHeight = document.getElementById("card_content_"+props.ad.id).offsetHeight;//+ 70;
        let time = proceduresLen(props.ad);
        if(time !== 0) dispatch(setHourHeight(60*cardHeight/time));
        e.stopPropagation();
        e.preventDefault();

    }

    const [cardCollapsed, setCollapsedCard] = useState(false);

    useEffect(()=>{
        let cardHeight = document.getElementById("card_content_"+props.ad.id).offsetHeight;// + 70;
        let time = proceduresLen(props.ad);
        setCollapsedCard((60*cardHeight/time) > props.hourHeight)

    },[props.hourHeight, props.cardConfig])


    const [size, setSize] = React.useState(1);

    useEffect(()=>{
        function handleResize() {
            if(document.getElementById(props.ad.id+(props.extraKey?props.extraKey:"")).offsetWidth > 600) {
                setSize(3);
            } else {
                setSize(1)
            }
        }

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);

    },[]);

    const getGenderIcon = (gender) => {
        switch (gender) {
            case "Female":
                return <div className={classes.femaleIcon}><FemaleIcon fontSize="small"/></div>
            case "Male":
                return <div className={classes.maleIcon}> <MaleIcon fontSize="small"/></div>
            case "Unspecified":
                return <div className={classes.unIcon}> <QuestionMarkIcon fontSize="small"/> </div>
            case "Not Known":
            default:
                return <div className={classes.unIcon}> <RadioButtonUncheckedIcon fontSize="small"/> </div>
        }
    }

    const getAddress = (addresses) => {
        if(addresses && addresses[0]) {
            const address = addresses[0];
            let text = address.postalCode ? `[${address.postalCode}] ` : '';
            if (address.addressLines && address.addressLines.length > 0) {
                address.addressLines.forEach(add => {
                    if(add) text += add + ' ';
                });
            }
            return text || "no address";
        } else {
            return "no address"
        }
    };

    const getBookTime = (operation) => {
        if(operation.listPos) return moment(operation.bookedDate).format("DD/MM/YYYY HH:mm") + " List pos: " + operation.listPos;
        return moment(operation.bookedDate).format("DD/MM/YYYY HH:mm");
    }


    const renderDetail = (type, text) => {
        if(props.ad[type])
        return  <div className={classes.admissionDetail} > <span style={{color: "#F7A202"}}><AlertIcon /></span> {text} </div>

    }

    const cardHaveAlerts = () => {
        return props.ad.icuHduBed || props.ad.radiologySupport || props.ad.requiresFirstAssistant
            || props.ad.specialistEquipment || props.ad.firstOnList || props.ad.lastOnList ||
            props.ad.amListOnly || props.ad.pacemakerCheck || props.ad.patientToStopAspirin || props.ad.patientToStopContPill
            || props.ad.diabetic || props.ad.idd || props.ad.latexAllergy
            || props.ad.requiresBariatricTable;
    }

    const getAdmissionDetails = () => {
        return <div >
            {renderDetail("icuHduBed", "ICU/HDU Bed")}
            {renderDetail("radiologySupport", "Radiology Support")}
            {renderDetail("requiresFirstAssistant", "Requires First Assistant")}
            {renderDetail("specialistEquipment", "Specialist Equipment")}
            {renderDetail("firstOnList", "First on list")}
            {renderDetail("lastOnList", "Last on list")}
            {renderDetail("amListOnly", "AM list only")}
            {renderDetail("pacemakerCheck", "Pacemaker Check")}
            {renderDetail("patientToStopAspirin", "Patient to stop aspirin")}
            {renderDetail("patientToStopContPill", "Patient to stop cont. pill")}
            {renderDetail("diabetic", "Diabetic")}
            {renderDetail("idd", "IDD")}
            {renderDetail("latexAllergy", "Latex Allergy")}
            {renderDetail("requiresBariatricTable", "Requires Bariatric table")}
        </div>
    }

    const operationIsPast = () => {
        let opLen = props.ad.proceduresLen?.reduce((accumulator, time) => accumulator + time, 0) || 0;
        return props.ad.bookedSession && moment(props.ad.bookedDate).add(opLen, "minutes").isBefore(moment());

    }
    const draftMode = useSelector(getDraftModeOn);

    const driverVisible = () => {
        return props.cardConfig.cancelReason || props.cardConfig.anaesthetic || props.cardConfig.overseeingConsultant || props.cardConfig.patientType ||
            props.cardConfig.transportType || props.cardConfig.whoCanOp || props.cardConfig.breachdate || props.cardConfig.MRSA || props.cardConfig.timeToComeIn || props.cardConfig.consultant || props.cardConfig.procedureNotesRefNote || props.cardConfig.infectionControlFlags
            || props.cardConfig.physicalSpecReq || props.cardConfig.additionalReferralNote || props.cardConfig.codeTuUse || props.cardConfig.letterPlease || props.cardConfig.notesClinicalTeamNotes || props.cardConfig.personCompRecord;
    }

    useEffect(()=> {
        let tmpTxt = "";
        if(props.ad.cancelInfo?.status === "rebook" && !props.ad.bookedSession) {
            tmpTxt += "REBOOK";
        }
        if(props.ad.patient == null) {
             if(tmpTxt.length > 0){
                tmpTxt += ", ";
            }
            tmpTxt += "MISSING PATIENT RECORD";
        }
        setTooltipText(tmpTxt);
    }, [props.ad])

    return(
        // <Tooltip title={(props.ad.cancelInfo?.status === "rebook" && !props.ad.bookedSession)? "REBOOK": ""} placement={'right'}>
        <Tooltip title={tooltipText} placement={'right'}>
            <div style={getItemStyle(props.markedOperation, props.ad, operationIsPast())}
                 id={props.ad.id+(props.extraKey? props.extraKey : "")}
                 className={clsx(classes.admissionCard)}
            >

                <div className={"card_"+(props.cardName? props.cardName: "")}
                    id={"card_"+props.ad.id+(props.extraKey? props.extraKey:"")}
                    style={{
                        height: props.calendar? proceduresLen(props.ad)/30*(props.hourHeight/2) - 5: "auto",
                        overflow: "hidden",
                        position: "relative"
                    }}>

                    <div id={"card_content_"+props.ad.id} style={{padding: "10px"}}>
                        <div className={classes.cardFirstBox}>
                            {props.cardConfig.patientDemographic &&
                                <div className={classes.patientName}
                                     style={{ top: 0, background: props.markedOperation? theme.palette.bookAdmissions.cardBackground: ""}}>
                                    <div className={classes.patientNameSize}> {props.ad.patientName} </div>
                                    {props.ad.patient?.dod && <div style={{color: "red"}}> DECEASED </div>}
                                    {cardCollapsed && <BackIcon onClick={handleExpandItem} className={classes.rotate}/>}
                                </div>
                            }
                            <div className={classes.patientDetails}>
                                {(props.cardConfig.age || props.cardConfig.hospitalNumber) && <div>
                                    {props.cardConfig.hospitalNumber && props.ad.patientId}
                                    {props.cardConfig.age && <> | Age: {props.ad.patientDob? moment().diff(props.ad.patientDob, 'years') : "-"} </>}
                                </div>
                                }
                                {props.cardConfig.gender && <div> {getGenderIcon(props.ad.patient?.gender)}</div> }
                                {props.cardConfig.priorityDescription && <div className={classes.priorityDescription} style={{background: priorityColors(props.ad.priority?.description), color: "white"}}> {props.ad.priority?.description? props.ad.priority?.description: "N/A"} </div>}
                                {props.cardConfig.addresses && <div>
                                    <div>
                                        {getAddress(props.ad.patient?.addresses)}
                                    </div>
                                </div>
                                }
                            </div>
                            {props.cardConfig.bookedTime && props.ad.bookedDate && <div> Booked Date: {getBookTime(props.ad)}</div> }
                            {props.cardConfig.procedure && <div className={classes.driver}/>}
                        </div>

                        <div>
                            <Grid container spacing={1} alignItems={"flex-start"}>
                                <Grid item xs={(12/size)}>
                                    {props.cardConfig.procedure && <div>
                                        {props.ad?.procedures?.map((procedure, index) => {
                                            return <div className={classes.parent} key={props.ad.__id+"proc"+index}>
                                                <div>
                                                    <div  className={classes.procedureSpecialty}> {procedure?.specialty} </div>
                                                </div>

                                                <div className={classes.procedureDescription}> {procedure?.__description}</div>
                                                <div  style={{textAlign: "center"}}> {procedureLenString(props.ad?.proceduresLen?.[index], props.timeFormat)}</div>

                                            </div>
                                        })}

                                        <div style={{display: "flex", alignItems: "center", marginTop: 10, justifyContent: "space-between"}}>
                                            <div style={{display: "flex", alignItems: "center"}}>
                                                <AccessTimeIcon className={classes.timeIcon}/> Total Time:
                                            </div>
                                            <b> {proceduresLenStringTotalTime(props.ad, props.timeFormat)} </b>
                                        </div>
                                        {driverVisible() && <div className={classes.driver}/>}
                                    </div>
                                    }
                                </Grid>
                                <Grid item xs={(12/size)}>
                                    {props.cardConfig.cancelReason && !props.ad.bookedSession && <div className={classes.cardDetails}>
                                        <span className={classes.label}>Cancel Reason:</span>
                                        <div className={classes.details}
                                             style={{color: "#F7A202"}}>{props.ad.cancelInfo?.notes}</div>
                                    </div>
                                    }
                                    {props.cardConfig.anaesthetic &&
                                    <div  className={classes.cardDetails}>
                                        <span className={classes.label}> Anaesthetic type: </span> <div className={classes.details}>{props.ad.anaestheticType?.description}</div>
                                    </div>
                                    }


                                    {props.cardConfig.overseeingConsultant &&
                                    <div  className={classes.cardDetails}>
                                        <span className={classes.label}> Overseeing Consultant:</span>
                                        <div className={classes.details}>{props.ad.overseeingConsultant?.name?props.ad.overseeingConsultant?.name: "-"}</div>
                                    </div>
                                    }

                                    {props.cardConfig.patientType &&
                                    <div  className={classes.cardDetails}>
                                        <span className={classes.label}>Patient Type:</span>
                                        <div className={classes.details}>{props.ad.patientType?.description?props.ad.patientType?.description: "-"}</div>
                                    </div>
                                    }

                                    {props.cardConfig.transportType &&
                                    <div  className={classes.cardDetails}>
                                        <span className={classes.label}>Transport Type: </span>
                                        <div className={classes.details}>{props.ad.transportType?.description? props.ad.transportType?.description: "-"}</div>
                                    </div>
                                    }
                                    {props.cardConfig.whoCanOp &&
                                    <div className={classes.cardDetails}>
                                        <span className={classes.label}> Who Could Op:</span>
                                        <div className={classes.details}>{props.ad.whoCouldOperate?.description? props.ad.whoCouldOperate?.description: "-"}</div>
                                    </div>
                                    }
                                    {props.cardConfig.breachdate &&
                                    <div  className={classes.cardDetails}>
                                        <span className={classes.label}> 18 wk Breach Date: </span>
                                        <div className={classes.details}>{props.ad.breachDate18wk?  moment(props.ad.breachDate18wk).format("DD/MM/YYYY"): "-"}</div>
                                    </div>
                                    }
                                    {props.cardConfig.MRSA &&
                                    <div  className={classes.cardDetails}>
                                        <span className={classes.label}> MRSA Screen:</span>
                                        <div className={classes.details}>{props.ad.mrsaScreen?.description? props.ad.mrsaScreen?.description : "-"}</div>
                                    </div>
                                    }
                                    {props.cardConfig.timeToComeIn && <div  className={classes.cardDetails}>
                                        <span className={classes.label}> Time To Come In  </span>
                                        <div className={classes.details}>
                                            {props.ad.referralNotes?.timeToComeIn?  props.ad.referralNotes?.timeToComeIn: "-"}
                                        </div>
                                    </div>}
                                    {props.cardConfig.consultant && <div>
                                        <div  className={classes.cardDetails}>
                                            <span className={classes.label}> Consultant </span>
                                            <div className={classes.details}>{props.ad.referralNotes?.consultant? props.ad.referralNotes?.consultant.name : "-"}</div>
                                        </div>
                                    </div>}

                                    {props.cardConfig.procedureNotesRefNote && <div>
                                        <div >
                                            <span className={classes.label}> Additional Procedure/Information </span>
                                            <div>{props.ad.referralNotes?.procedureNotes? props.ad.referralNotes?.procedureNotes : "-"}</div>
                                        </div>
                                    </div>}

                                    {props.cardConfig.infectionControlFlags && <div>
                                        <div >
                                            <span className={classes.label}> Infection Control Flags </span>
                                            <div>{props.ad.referralNotes?.infectionControlFlags? props.ad.referralNotes?.infectionControlFlags : "-"}</div>
                                        </div>
                                    </div>}

                                    {props.cardConfig.physicalSpecReq && <div>
                                        <div >
                                            <span className={classes.label}> Physical/Special Requirements </span>
                                            <div>{props.ad.referralNotes?.physicalSpecReq? props.ad.referralNotes?.physicalSpecReq : "-"}</div>
                                        </div>
                                    </div>}

                                    {props.cardConfig.additionalReferralNote && <div>
                                        <div>
                                            <span className={classes.label}> Additional Referral Note </span>
                                            <div>{props.ad.referralNotes?.additionalReferralNote? props.ad.referralNotes?.additionalReferralNote : "-"}</div>
                                        </div>
                                    </div>}

                                    {props.cardConfig.codeTuUse && <div>
                                        <div  className={classes.cardDetails}>
                                            <span className={classes.label}> Code Tu Use </span>
                                            <div className={classes.details}>{props.ad.clinicalTeamNotes?.codeTuUse? props.ad.clinicalTeamNotes?.codeTuUse.description : "-"}</div>
                                        </div>
                                    </div>}
                                    {props.cardConfig.letterPlease && <div>
                                        <div  className={classes.cardDetails}>
                                            <span className={classes.label}> Letter Please </span>
                                            <div className={classes.details}>{props.ad.clinicalTeamNotes?.letterPlease? props.ad.clinicalTeamNotes?.letterPlease.description : "-"}</div>
                                        </div>
                                    </div>}
                                    {props.cardConfig.notesClinicalTeamNotes && <div>
                                        <div>
                                            <span className={classes.label}> Clinical/Team Notes </span>
                                            <div>{props.ad.clinicalTeamNotes?.notes? props.ad.clinicalTeamNotes?.notes : "-"}</div>
                                        </div>
                                    </div>}
                                    {props.cardConfig.personCompRecord && <div>
                                        <div  className={classes.cardDetails}>
                                            <span className={classes.label}> Person Completing Record </span>
                                            <div className={classes.details}>{props.ad.personCompRecord?.personCompleting? props.ad.personCompRecord?.personCompleting : "-"}</div>
                                        </div>
                                        <div  className={classes.cardDetails}>
                                            <span className={classes.label}>Completed On </span>
                                            <div className={classes.details}>
                                                {props.ad.personCompRecord?.recordCompleted?  moment(props.ad.personCompRecord?.recordCompleted).format("DD/MM/YYYY"): "-"}
                                            </div>
                                        </div>
                                    </div>}
                                </Grid>

                                <Grid item xs={(12 / size)}>
                                    {(props.cardConfig.admissionDetails || props.cardConfig.note || props.cardConfig.procedureNotes)
                                    && (props.ad.notes || props.ad.procedureNotes || cardHaveAlerts())
                                    && <div
                                        className={props.markedOperation ? classes.admissionCardDetailMarkedOperation : classes.admissionCardDetail}>
                                        {props.cardConfig.admissionDetails && getAdmissionDetails()}
                                        {props.cardConfig.note && <div style={{margin: "5px"}}> {props.ad.notes} </div>}
                                        {props.cardConfig.procedureNotes &&
                                        <div style={{margin: "5px"}}> {props.ad.procedureNotes} </div>}
                                    </div>
                                    }
                                </Grid>
                            </Grid>



                            {props.calendar && !draftMode  &&
                            //  <div className={classes.expandButton} style={{background: props.markedOperation? "white": ""}}>
                            <div>

                                {props.ad.patient === null &&
                                    <div style={{padding: 5, pointerEvents: "none"}}>
                                        <Button
                                            size="small"
                                            fullWidth
                                            color={"error"}
                                            variant="outlined">
                                            Missing Patient Record
                                        </Button>
                                    </div>
                                }
                                {props.ad.patient !== null && !configFile.endSurgeryHidden &&
                                    <div style={{padding: 5}}>
                                        <Button
                                            size="small"
                                            fullWidth
                                            color={props.ad.endSurgery ? "success" : "primary"}
                                            disabled={!userCanEditForm()}
                                            onClick={saveEndSurgery}
                                            variant="outlined">
                                            {props.ad.endSurgery ? "Ended at " + moment(props.ad.endSurgery).format("DD/MM HH:mm") : "End Surgery"}
                                        </Button>
                                    </div>
                                }

                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Tooltip>


    );
}

export default memo(AdmissionPatientCard)